import React from 'react';
import { AuthProvider } from './AuthContext';
import { EntitlementProvider } from './EntitlementContext';
import { FinancialPlanProvider } from './FinancialPlanContext';

export function AppProvider({ children }) {
  return (
    <AuthProvider>
      <EntitlementProvider>
        <FinancialPlanProvider>
          {children}
        </FinancialPlanProvider>
      </EntitlementProvider>
    </AuthProvider>
  );
}
